import APIAxios from '../APIAxios.ts';

const fetchTeams = async () => {
    try {
      const response = await APIAxios.get('/StaticData/GetTeams');
      const data = response.data;
      return data;
    } catch (err) {
        throw err;
    }
  };

  const fetchAttributes = async () => {
    try {
      const response = await APIAxios.get('/StaticData/GetAttributes');
      const data = response.data;
      return data;
    } catch (err) {
        throw err;
    }
  };


  const staticDataService = {
    fetchTeams,
    fetchAttributes
  };
  
  export default staticDataService;
  